package presentation.screens.changePassword

import utils.UiAction
import utils.UiState

sealed interface ChangePasswordMVIAction : UiAction {

    data class NewPasswordChanged(val password: String) : ChangePasswordMVIAction
    data class CurrentPasswordChanged(val password: String) : ChangePasswordMVIAction
    data class ConfirmPasswordChanged(val password: String) : ChangePasswordMVIAction
    data object ChangeClicked : ChangePasswordMVIAction
    data object ErrorDismissed : ChangePasswordMVIAction
    data object BackClicked : ChangePasswordMVIAction
}

data class ChangePasswordState(
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    val token: String? = null,
    val currentPassword: String = "",
    val isCurrentPasswordError: Boolean = false,
    val isCurrentPasswordVisible: Boolean = false,
    val newPassword: String = "",
    val isNewPasswordError: Boolean = false,
    val isNewPasswordVisible: Boolean = false,
    val confirmPassword: String = "",
    val isConfirmPasswordError: Boolean = false,
    val isConfirmPasswordVisible: Boolean = false,
) : UiState